import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-platform-services',
  templateUrl: './platform-services.component.html',
  styleUrls: ['./platform-services.component.scss']
})
export class PlatformServicesComponent implements OnInit {
  entityHashId: string = ''
  loader: boolean = false
  constructor(private _navService: NavigationService,private dialog: MatDialog, private loaderservice: LoaderServiceService, private router: Router,private route:ActivatedRoute) {
    this._navService.hideSidebarAndNav = false;
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.loaderservice.showLoader = true
    this.loader = true
    setTimeout(() => {
      this.loaderservice.showLoader = false
      this.loader = false
    }, 100);

  }

  openAlert(){
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
      width: '400px',
      data : {
        title : 'Alert',
        message : 'Coming soon in the upcoming new version. You can also send request via Support section for an early update.',
        okbtn : 'Ok',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
      },
      disableClose : true
    });
  }

  openSalesReport(){
    this.router.navigate(["/businesses", "details", "reports", "sales-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openEmployeeSalesReport(){
    this.router.navigate(["/businesses", "details", "reports", "employee-sales-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openExpenditureReport(){
    this.router.navigate(["/businesses", "details", "reports", "expenditure-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openEmployeeSalaryReport(){
    this.router.navigate(["/businesses", "details", "reports", "employee-salary-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openBookingsReport(){
    this.router.navigate(["/businesses", "details", "reports", "booking-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openServiceReport(){
    this.router.navigate(["/businesses", "details", "reports", "service-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openInvoiceReport(){
    this.router.navigate(["/businesses", "details", "reports", "invoice-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openOnlinePaymentReport(){
    this.router.navigate(["/businesses", "details", "reports", "online-payments-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openInventoryActivityReport(){
    this.router.navigate(["/businesses", "details", "reports", "inventory-activity-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openPurchaseReport(){
    this.router.navigate(["/businesses", "details", "reports", "purchase-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openProfitAnalysisReport(){
    this.router.navigate(["/businesses", "details", "reports", "profit-analysis-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openTaxCollectionReport(){
    this.router.navigate(["/businesses", "details", "reports", "tax-collection-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }

}
